<div class="projects mb-4">
    <div class="card">
            <div class="card-header header-background">
                  <div class="row">
                      <div class="col-sm-3">
                          <h2>Validación</h2>
                      </div>
                  </div>
            </div>
    

            <div>
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#resumen">Resumen</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" (click)="showDetalle = true" href="#detalle">Detalle</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" (click)="showApelacion = true" href="#apelacion"> Apelaciones </a>
                    </li>
                </ul>
                <div id="myTabContent" class="tab-content">

                    <div class="tab-pane fade show active" id="resumen">
                        <div style="padding: 20px 50px;">
                            <div class="row">
                                <app-validacion-resumen ></app-validacion-resumen>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade show" id="detalle">
                        <div style="padding: 20px 50px;">
                            <div class="row">
                                <app-validacion-seguimiento *ngIf="showDetalle"></app-validacion-seguimiento> 
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade show" id="apelacion">
                        <div style="padding: 20px 50px;">
                            <div class="row">
                                <app-apelaciones-seguimiento *ngIf="showApelacion"></app-apelaciones-seguimiento>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
    </div>
  </div>


<!-- <mat-drawer-content style="margin-left: 1px;">
    <app-validacion-inicio *ngIf="menuMostrar==='inicio'"></app-validacion-inicio>  
    <app-validacion-resumen *ngIf="menuMostrar==='resumen'"></app-validacion-resumen>
    <app-validacion-seguimiento *ngIf="menuMostrar==='validacion-seguimiento'"></app-validacion-seguimiento>  
    <app-informe-seguimiento *ngIf="menuMostrar==='informe-seguimiento'"></app-informe-seguimiento>  
    <app-apelaciones-seguimiento *ngIf="menuMostrar==='apelaciones-seguimiento'"></app-apelaciones-seguimiento>     
</mat-drawer-content> -->